import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NewsItemComponent } from '@app/shared/news-item/news-item.component';
import { WucPictureModule } from '@inshared/website-ui-components';

/** @deprecated use NewsItemModule from libs */
@NgModule({
    declarations: [NewsItemComponent],
    exports: [NewsItemComponent],
    imports: [CommonModule, WucPictureModule],
})
export class NewsItemModule {}
